import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import CheckboxField from 'components/forms/checkboxField/CheckboxField';
import { SettingsSectionStyled } from '../../DirectBookingEngine.styles';

const WidgetSettingsSection = () => {
  const { t } = useTranslation();

  return (
    <SettingsSectionStyled
      data-testid="widget-settings-section"
      defaultExpanded
      label={t('pageDirectBookingEngine.widgetSettings.sectionTitle')}
      variant="card"
    >
      <Row>
        <Col sm={9} smOffset={3}>
          <CheckboxField name="widgetSettings.requireGuestPhoneNumber">
            {t(
              'pageDirectBookingEngine.widgetSettings.requireGuestPhoneNumber',
            )}
          </CheckboxField>
          <CheckboxField name="widgetSettings.hidePriceWhenDateNotEntered">
            {t(
              'pageDirectBookingEngine.widgetSettings.hidePriceWhenDateNotEntered',
            )}
          </CheckboxField>
        </Col>
      </Row>
    </SettingsSectionStyled>
  );
};

export default WidgetSettingsSection;
